module.exports = __webpack_public_path__ + "media/images/icons/outlined/copyright-circle-f4290c813d1c46da292e13aefff9a6d5.svg";